// removed by extract-text-webpack-plugin
module.exports = {"payment-error-modal-wrapper":"app-components-PaymentGatewayErrorModal-__PaymentGatewayErrorModal___LwOji","dialog":"app-components-PaymentGatewayErrorModal-__PaymentGatewayErrorModal___1y-FY","mt-20px":"app-components-PaymentGatewayErrorModal-__PaymentGatewayErrorModal___3rlzf","text-grey":"app-components-PaymentGatewayErrorModal-__PaymentGatewayErrorModal___1PdO9","font-medium":"app-components-PaymentGatewayErrorModal-__PaymentGatewayErrorModal___WSUjs","mb-20px":"app-components-PaymentGatewayErrorModal-__PaymentGatewayErrorModal___1cwi4"};


//////////////////
// WEBPACK FOOTER
// ./app/components/PaymentGatewayErrorModal/PaymentGatewayErrorModal.css
// module id = 1985
// module chunks = 0